import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, MapPin, ArrowRight } from "lucide-react";
import api from "../lib/api";

export default function Schedule() {
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get("/public/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);
  const price = settings?.course_price ?? 405;
  const term = settings?.current_term ?? "Summer 2026";
  const sessions = [
    { label: "Tuesday Morning" },
    { label: "Tuesday Afternoon" },
    { label: "Friday Evening" },
  ];

  return (
    <div data-testid="schedule-page">
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-10">
        <div className="font-hand text-[#A685BD] text-2xl">{term}</div>
        <h1 className="font-display text-5xl md:text-6xl text-[#5D2C8F] mt-2 brush-underline">Schedule</h1>
        <p className="mt-6 text-[#5A4A6B] max-w-2xl leading-relaxed">
          Three sessions a week. All classes run for 14 weeks with a final exhibition in Week 14.
        </p>
        <div className="mt-5 inline-flex items-baseline gap-3 bg-[#FAF6EE] px-5 py-3 rounded-2xl">
          <span className="font-display italic text-[#5D2C8F] text-3xl leading-none">From £{price}</span>
          <span className="text-sm text-[#8A6DA3]">· full 14-week term</span>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 lg:px-10 pb-20 grid md:grid-cols-3 gap-6">
        {sessions.map((s) => (
          <div key={s.label} className="soft-card p-7 hover:-translate-y-1 transition-transform" data-testid={`session-card-${s.label.toLowerCase().replace(/\s/g,'-')}`}>
            <div className="h-12 w-12 rounded-2xl bg-[#8EC9C7]/25 flex items-center justify-center text-[#5D2C8F] mb-4"><CalendarDays size={22} /></div>
            <div className="font-display text-2xl text-[#5D2C8F]">{s.label}</div>
            <div className="flex items-center gap-2 text-[#8A6DA3] text-sm mt-2"><MapPin size={14} /> East Croydon studio</div>
            <Link to="/contact" className="sac-btn-primary mt-5 !py-2 !px-5 text-sm" data-testid={`book-${s.label.toLowerCase().replace(/\s/g,'-')}-btn`}>
              Enquire <ArrowRight size={16} />
            </Link>
          </div>
        ))}
      </section>
    </div>
  );
}
